<div class="border-top">
  <div class="guts-m-full-1">
    <nav [attr.aria-label]="i18n.DashboardNav_Resources">
      <ul>
        <li
          *ngFor="let resource of resources; let isFirst = first"
          class="guts-m-t-half resource-link color-ebony-a61"
          [class.first-resource-link]="isFirst"
          data-dgat="learner-home-resources-cbc"
        >
          <div
            [ngClass]="{
              'selected-resource': resource.link === selectedPage
            }"
            class="resource-container l_flex"
          >
            <a
              [routerLink]="resource.link"
              (click)="trackClick(resource.label, resource.link)"
              data-dgat="learner-home-resources-76e"
              class="l_flexbar full-width"
            >
              {{ resource.label }}
              <ng-container
                *ngTemplateOutlet="
                  resource.customTemplate
                    ? resource.customTemplate
                    : defaultTemplate
                "
              >
              </ng-container>
            </a>
          </div>
        </li>
      </ul>
    </nav>

    <ng-template #defaultTemplate> </ng-template>

    <ng-template #assignmentsBadge>
      <div
        *ngIf="!isLoading; else skeleton"
        class="badge badge-pill badge-pill--compact guts-m-l-auto"
        tabindex="0"
        [ngClass]="getAssignmentsBadgeColor(assignmentsCounts)"
        [ngbTooltip]="assignmentsBadgeTooltip"
        placement="top-right auto"
        [attr.aria-label]="assignmentsCountAriaLabel"
      >
        {{ assignmentsCounts.recommendedLearningTotal }}
      </div>
      <ng-template #skeleton>
        <div class="skeleton-container guts-m-l-auto">
          <div
            class="
              skeleton skeleton__tooltip
              bg-animate
              grid__col-xs-1
              guts-p-full-0
            "
          ></div>
        </div>
      </ng-template>
    </ng-template>

    <ng-template #assignmentsBadgeTooltip>
      <div class="assignments-tooltip">
        <ul>
          <li class="l_flex guts-m-v-quart">
            <df-icon
              class="color-error"
              icon="record"
              size="extra-small"
            ></df-icon>
            <span class="label guts-m-r-2">{{
              i18n.dgAssignmentsOverview_Overdue
            }}</span>
            <span class="count guts-m-l-auto">{{
              assignmentsCounts.recommendedLearningOverdue
            }}</span>
          </li>
          <li class="l_flex guts-m-b-quart">
            <df-icon
              class="color-warning"
              icon="record"
              size="extra-small"
            ></df-icon>
            <span class="label guts-m-r-2">{{
              i18n.dgAssignmentsOverview_DueSoon
            }}</span>
            <span class="count guts-m-l-auto">{{
              assignmentsCounts.recommendedLearningDueSoon
            }}</span>
          </li>
          <li class="l_flex guts-m-b-quart">
            <df-icon
              class="color-blue"
              icon="record"
              size="extra-small"
            ></df-icon>
            <span class="label guts-m-r-2">{{
              i18n.dgAssignmentsOverview_Incomplete
            }}</span>
            <span class="count guts-m-l-auto">{{
              assignmentsCounts.recommendedLearningDueLater
            }}</span>
          </li>
        </ul>
      </div>
    </ng-template>
  </div>
</div>
